import React from "react";

// Mascote da Art3D — polvo fofo em SVG (placeholder da logo, substituível pelo painel)
export function OctopusMascot({ size = 48, className = "", wave = false }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Mascote polvo Art3D"
    >
      <defs>
        <linearGradient id="octoBody" x1="20" y1="10" x2="100" y2="110" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF69B4" />
          <stop offset="0.55" stopColor="#FF1493" />
          <stop offset="1" stopColor="#9370DB" />
        </linearGradient>
      </defs>
      {/* body */}
      <path
        d="M60 12C36 12 22 30 22 52c0 10 3 17 8 23-4 2-8 6-8 11 0 5 4 8 8 7-1 4 1 9 6 10 4 1 7-1 9-4 1 4 5 7 10 7s9-3 10-7c2 3 5 5 9 4 5-1 7-6 6-10 4 1 8-2 8-7 0-5-4-9-8-11 5-6 8-13 8-23 0-22-14-40-38-40Z"
        fill="url(#octoBody)"
      />
      {/* tentacle curls */}
      <path d="M30 88c-4 4-4 10 1 13" stroke="#DDA0DD" strokeWidth="4" strokeLinecap="round" />
      <path d="M90 88c4 4 4 10-1 13" stroke="#00CED1" strokeWidth="4" strokeLinecap="round" />
      {wave && (
        <path d="M96 40c8-6 14-4 16 2" stroke="#FF1493" strokeWidth="5" strokeLinecap="round" />
      )}
      {/* face */}
      <circle cx="48" cy="50" r="6.5" fill="#0F172A" />
      <circle cx="74" cy="50" r="6.5" fill="#0F172A" />
      <circle cx="50" cy="48" r="2.2" fill="#fff" />
      <circle cx="76" cy="48" r="2.2" fill="#fff" />
      <path d="M54 64c3 3.5 9 3.5 12 0" stroke="#0F172A" strokeWidth="3.5" strokeLinecap="round" />
      {/* cheeks */}
      <ellipse cx="39" cy="61" rx="5" ry="3.4" fill="#FFB6D9" opacity="0.9" />
      <ellipse cx="83" cy="61" rx="5" ry="3.4" fill="#FFB6D9" opacity="0.9" />
      {/* spots */}
      <circle cx="40" cy="30" r="4" fill="#DDA0DD" opacity="0.7" />
      <circle cx="80" cy="26" r="3" fill="#00CED1" opacity="0.6" />
    </svg>
  );
}

export default OctopusMascot;
